import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppConstant, CryptoKeyValue } from '@app/shared/constants';
import { BehaviorSubject } from 'rxjs';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { IUserLocalDetails } from '@app/core/services/localStorage/Ilocal-storage.interface';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { InvoiceFilterModel } from '../../../feature/super-admin/models/client';
import { EncrDecrService } from '../encr-decr-service.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private _designShopify = new BehaviorSubject({ shopify: false });

  constructor(private http: HttpClient,
    private ls: LocalStorageService, private EncrDecr: EncrDecrService) {
    if (document.location.ancestorOrigins != undefined && document.location.ancestorOrigins != null && document.location.ancestorOrigins.length !== 0) {
      this.changeShopifyDesign(true);
    }
  }

  subShopifyDesign() {
    return this._designShopify.asObservable();
  }

  changeShopifyDesign(arg: boolean) {
    if (arg) {
      $('#overRuleCss').attr('href', 'assets/css/overrule.css');
    } else {
      $('#overRuleCss').attr('href', '');
    }
    this._designShopify.next({ shopify: arg });
  }
  /**Get store by name, checks whether store exists or not
   *@param storeName StoreNAME
   *@returns true/false
  */
  getStoreByName(storeName: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_STOREBYNAME + '?StoreName=' + storeName);
  }

  /** Function to check for null | undefined | empty String */
  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }

  /** Calculate the difference between date2 and date1
    *@param date1 
    *@param date2
    *@returns days
  */
  fn_CalculateDateDiff(date2: any, date1: any) {
    const diffDays = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  fn_getImageUrl(url: string, colorName: string) {
    let arr = url.split('/');
    colorName = colorName.replace(/\//g, '');
    arr[7] = colorName.replace(/ /g, '_');
    const imagePath = arr.join('/');
    return imagePath;
  }

  updateStoreTheme(colorScheme: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_STORETHEME, colorScheme);
  }

  updateDefaultStoreTheme(storeId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.RESET_STORETHEME + '?StoreId=' + storeId);
  }

  fn_CalculateTotalCost(unitprice: number, finishingCost: number, printCost: number, sideCount: number, profit: number, IsEmbroidery: boolean = false,IsWareHouseProduct: boolean = false) {
    var totalcost = 0
    if(!sideCount){
      sideCount = 1
    }
    if(IsWareHouseProduct){
      totalcost = unitprice + finishingCost + profit;
    }else{
    if (!IsEmbroidery)
      totalcost = unitprice + finishingCost + (printCost * (sideCount - 1)) + profit;
    else
      totalcost = unitprice + finishingCost + (printCost * (sideCount - 1)) + profit;
    }
      return totalcost;
  }
  fn_calculateDiscount(totalAmounted: number, discountedPercantage: number) {
    var discounteAmount = totalAmounted - (totalAmounted * (discountedPercantage / 100));
    return discounteAmount;    
  }
  /**Gets store listing with params: searchString, skipNoOfRecord, takeNoRecord, IsPaginationFilteringRequired.
   * IsPaginationFilteringRequired = false, means pagination, searching, filterinig is not required */
  getStoreList(searchString: any, skipNoOfRecord: number, takeNoRecord: number, IsPaginationFilteringRequired: boolean,
    ApplicationUserId: any, getShopifyStore: boolean) {
    return this.http.get<APIResponse<GetStoreInterface[]>>(environment.baseUrl + AppConstant.STORE_GETALL + '?searchBy=' + searchString +
      '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord + '&IsPaginationFilteringRequired=' + IsPaginationFilteringRequired +
      '&ApplicationUserId=' + ApplicationUserId + '&GetShopifyStore=' + getShopifyStore);
  }
  getStoreListDashboard(searchString: any, skipNoOfRecord: number, takeNoRecord: number, IsPaginationFilteringRequired: boolean,
    ApplicationUserId: any, getShopifyStore: boolean) {
    return this.http.get<APIResponse<GetStoreInterface[]>>(environment.baseUrl + AppConstant.DASHBOARDSTORE_GETALL + '?searchBy=' + searchString +
      '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord + '&IsPaginationFilteringRequired=' + IsPaginationFilteringRequired +
      '&ApplicationUserId=' + ApplicationUserId + '&GetShopifyStore=' + getShopifyStore);
  }

  updateDailyVistor(storeId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.UPDATE_DAILY_VISITOR_CR + '?StoreId=' + storeId);
  }

  getOpenCartsQuery(storeId: any, userId = localStorage.getItem('userId')) {
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_OPEN_CARTS_QUERY + '?StoreId=' + storeId + '&UserId=' + userId);
  }

  getDailyVisitors(storeId: any, userId = localStorage.getItem('userId')) {
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_DAILY_VISITORS + '?StoreId=' + storeId + '&UserId=' + userId);
  }

  updateDesignViewedCount(storeId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.UPDATE_DESIGN_VIEWED_COUNT + '?StoreId=' + storeId);
  }

  getDesignViewedCount(storeId: any, userId = localStorage.getItem('userId')) {
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_DESIGN_VIEWED_COUNT + '?StoreId=' + storeId + '&UserId=' + userId);
  }

  getAboutStoreDetails(storeId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_ABOUT_STORE + '?StoreId=' + storeId);
  }

  addUpdatePrivacyPolicyAndTermsofUse(data: any) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_UPDATE_PRIVACYPOLICY_TERMSOFUSE, data);
  }

  uploadFile(data: { UserID: string; File: string; ext: 'jpg' | 'png' | string }) {
    return this.http.post<APIResponse<string>>(environment.baseUrl + AppConstant.POST_UPLOAD_FILE, data);
  }

  uploadHuddleLogo(data: { File: string; Extension: string }) {
    return this.http.post<APIResponse<string>>(environment.baseUrl + AppConstant.POST_UPLOAD_HUDDLE_LOGO, data);
  }

  getPrivacyPolicyAndTermsofUse() {
    return this.http.get(environment.baseUrl + AppConstant.GET_PRIVACYPOLICY_TERMSOFUSE);
  }


  getUser(): IUserLocalDetails {
    return this.ls.getObject<IUserLocalDetails>(new IUserLocalDetails());
  }

  getInvoiceList(filterModel: InvoiceFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.GET_INVOICE_LIST, filterModel);
  }
  getDetailedInvoice(invoiceno: any, userId: number) {
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_DETAILED_INVOICE_LIST + '?InvoiceId=' + invoiceno + '&userId=' + userId);
  }
  getCategories() {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_PRODUCT_CATEGORIES_LIST);
  }
  getSubCategories(categoryID: number) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_PRODUCT_SUB_CATEGORIES_LIST + '?CategoryId=' + categoryID);
  }
  getDropdownData() {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_PRODUCT_DROPDOWN_LIST);
  }

  fn_CrytoEncryptDecryptText(id: any) {
    return this.EncrDecr.set(CryptoKeyValue.Key, String(id));
  }
  getAllReleaseNoteList(take: number, skip: number, isShopify: boolean) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_ALL_RELEASE_LIST + '?Take=' + take + '&Skip=' + skip + '&IsShopify=' + isShopify);
  }
  dismissReleaseNote() {
    return this.http.get(environment.baseUrl + AppConstant.DISMIS_RELEASE_NOTE +'?IsShopify='+false);
  }
  GetPermissionList(userId: number) {
    return this.http.get(environment.baseUrl + AppConstant.GET_STORE_PERMISSION + userId);
  }

  getOutofStockProductsDetail(filters?: { vendor?: string; reason?: string; status?: string; search?: string }) {
    let url = environment.baseUrl + AppConstant.GET_OUT_OF_STOCK_PRODUCTS;
    if (filters) {
      const params: string[] = [];
      if (filters.vendor) { params.push('vendor=' + encodeURIComponent(filters.vendor)); }
      if (filters.reason) { params.push('reason=' + encodeURIComponent(filters.reason)); }
      if (filters.status) { params.push('status=' + encodeURIComponent(filters.status)); }
      if (filters.search) { params.push('search=' + encodeURIComponent(filters.search)); }
      if (params.length) { url += '?' + params.join('&'); }
    }
    return this.http.get(url);
  }

  updateOutOfStockAction(payload: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_OUT_OF_STOCK_ACTION, payload);
  }

  markOutOfStockDiscontinued(payload: any) {
    return this.http.post(environment.baseUrl + AppConstant.MARK_OUT_OF_STOCK_DISCONTINUED, payload);
  }
}
